import { AuthRepository } from '../features/authentication/data/repositories/auth-repository'
import { GetTimeRepository } from '../features/authentication/data/repositories/get-time-repository'
import { AuthController } from '../features/authentication/presentation/controllers/auth-controller'
import { GetTimeController } from '../features/authentication/presentation/controllers/get-time-controller'
import { AuthService } from '../features/authentication/service/auth-service'
import { GetTimeService } from '../features/authentication/service/get-time-service'

export const makeAccess = async () => {
  const getTimeDataSource = new GetTimeService()
  const getTimeRepository = new GetTimeRepository(getTimeDataSource)
  const getTimeController = new GetTimeController(getTimeRepository)
  const key = await getTimeController.getTime()

  const authDataSource = new AuthService()
  const authRepository = new AuthRepository(authDataSource, key)
  const authController = new AuthController(authRepository)
  const token = await authController.getToken()
  
  return { key, token }
}
